import { render, staticRenderFns } from "./complete.vue?vue&type=template&id=6774d067&lang=pug&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\git\\front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6774d067')) {
      api.createRecord('6774d067', component.options)
    } else {
      api.reload('6774d067', component.options)
    }
    module.hot.accept("./complete.vue?vue&type=template&id=6774d067&lang=pug&", function () {
      api.rerender('6774d067', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/mail/complete.vue"
export default component.exports